<template>
  <div class="tracker">
    <div class="row">

      <div class="col-lg-6">
        <b-card no-block
                variant="outline-primary"
                header="Current Initiative Pass"
                :inverse="false">
          <b-table striped hover
                   class="card-table"
                   :items="ipTableItems"
                   :fields="ipTableFields">
            <template slot="name" scope="data">
              <span v-bind:class="{ 'text-completed': data.item.completed }">
                {{data.value}}
              </span>
            </template>
            <template slot="initiative" scope="data">
              <span v-bind:class="{ 'text-completed': data.item.completed }">
                {{data.value}}
              </span>
            </template>
          </b-table>
        </b-card>
        
        <b-card no-block
                variant="outline-secondary"
                header="Upcoming"
                class="mt-4">
          <b-table striped
                  class="card-table"
                  :items="upcomingItems"
                  :fields="upcomingFields">
            <template slot="name" scope="data">{{data.value}}</template>
            <template slot="initiative" scope="data">{{data.value}}</template>
            <template slot="combatTurn" scope="data">{{data.value}}</template>
          </b-table>
        </b-card>
      </div>

      <div class="col-lg-6">
        <h2>It's Six's turn.</h2>
        <p>
          Current combat turn: {{combatTurn}} <br />
          Current initiative: {{initiative}}
        </p>
      </div>

    </div>

  </div>
</template>

<script>
const initiativePass = [
  { type: 'character', initiative: 22, name: 'Jake Armitage', combatTurn: 4, completed: true },
  { type: 'character', initiative: 12, name: 'Six', combatTurn: 4, completed: false, _rowVariant: 'success' },
  { type: 'event', initiative: 6, name: 'Grenade', combatTurn: 4, completed: false }
]

const upcoming = [
  { type: 'event', initiative: 12, name: 'Grenade', combatTurn: 5 }
]

const ipTableFields = {
  initiative: { label: 'Initiative' },
  name: { label: 'Name' }
}

const upcomingFields = {
  combatTurn: { label: 'Combat Turn' },
  initiative: { label: 'Initiative' },
  name: { label: 'Name' }
}

export default {
  name: 'tracker',
  data () {
    return {
      ipTableItems: initiativePass,
      ipTableFields: ipTableFields,
      upcomingItems: upcoming,
      upcomingFields: upcomingFields,
      combatTurn: 4,
      initiative: 12
    }
  }
}
</script>


// WEBPACK FOOTER //
// Tracker.vue?df7af97e